import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { HttpMockService } from './http-mock.types';

@Injectable({ providedIn: 'root' })
export class HttpMockManagerService {
  readonly #services: HttpMockService[] = [];

  get(req: HttpRequest<unknown>): unknown | null {
    for (const service of this.#services) {
      const result = service.get(req);
      if (result !== null) {
        return result;
      }
    }

    return null;
  }

  register(mockService: HttpMockService): void {
    this.#services.push(mockService);
  }
}
